module.exports = __webpack_public_path__ + "static/media/previous_section_hover.e0a80e7a.svg";